module.exports = __webpack_public_path__ + "img/tz07.ccac3788.jpg";